interface FAQItem {
 question: string;
 answer: string;
}

interface FAQSectionProps {
 title?: string;
 faqs: FAQItem[];
}

export function FAQSection({ title = "Frequently Asked Questions", faqs }: FAQSectionProps) {
 if (faqs.length === 0) return null;

 return (
 <section className="py-16">
	 <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
		 <h2 className="text-3xl font-bold text-foreground mb-8">{title}</h2>
		 <div className="space-y-4">
	{faqs.map((faq, i) => (
 <details
 key={i}
 className="group bg-popover border border-border rounded-xl overflow-hidden"
 >
 <summary className="flex items-center justify-between cursor-pointer px-6 py-4 font-semibold text-foreground hover:bg-muted transition-colors">
 <span>{faq.question}</span>
 <span className="ml-4 shrink-0 text-muted-foreground group-open:rotate-45 transition-transform duration-200 text-xl">+</span>
 </summary>
 <div className="px-6 pb-4 text-muted-foreground leading-relaxed">
 {faq.answer}
 </div>
 </details>
 ))}
		 </div>
	 </div>
 </section>
 );
}
